/* BreakoutLabs — Test Collection Guide. Scrollspy + battery-friendly loop playback. */
(function () {
  'use strict';

  /* Only play the loop clips that are actually on screen. Keeps a phone in the
     kitchen from decoding seven videos at once. */
  function initLoops(root) {
    var vids = root.querySelectorAll('video[data-loop]');
    if (!vids.length) return;
    if (!('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(vids, function (v) { v.play().catch(function () {}); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) { v.play().catch(function () {}); }
        else { v.pause(); }
      });
    }, { rootMargin: '160px 0px', threshold: 0.15 });
    Array.prototype.forEach.call(vids, function (v) { io.observe(v); });
  }

  /* Sticky step chips highlight whichever step you're working on. */
  function initSpy(nav) {
    var links = Array.prototype.slice.call(nav.querySelectorAll('a[href^="#"]'));
    if (!links.length) return;
    var targets = links
      .map(function (a) {
        var el = document.getElementById(a.getAttribute('href').slice(1));
        return el ? { a: a, el: el } : null;
      })
      .filter(Boolean);
    if (!targets.length) return;

    function setActive(a) {
      links.forEach(function (l) { l.classList.toggle('on', l === a); });
      /* keep the active chip visible in the scroller without moving the page */
      var t = nav.querySelector('.track');
      if (!t || !a) return;
      var left = a.offsetLeft - (t.clientWidth - a.offsetWidth) / 2;
      t.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
    }

    function onScroll() {
      var line = window.innerHeight * 0.34;
      var current = targets[0];
      for (var i = 0; i < targets.length; i++) {
        if (targets[i].el.getBoundingClientRect().top <= line) current = targets[i];
      }
      if (current && !current.a.classList.contains('on')) setActive(current.a);
    }

    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () { onScroll(); ticking = false; });
    }, { passive: true });
    onScroll();
  }

  /* Poster stays a plain image until tapped, then the real player loads.
     No third-party script runs for people who never press play. */
  function initFacade(root) {
    root.querySelectorAll('[data-video-facade]').forEach(function (box) {
      var btn = box.querySelector('.play');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var src = box.getAttribute('data-video-src');
        if (!src) return;
        var f = document.createElement('iframe');
        f.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'autoplay=1';
        f.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture');
        f.setAttribute('allowfullscreen', '');
        f.setAttribute('title', box.getAttribute('data-video-title') || 'Collection walkthrough');
        box.appendChild(f);
        btn.remove();
      });
    });
  }

  /* Belt and braces for the sticky rescue in dc-guide.css, for anything that
     doesn't support :has(). An ancestor with a non-visible overflow turns into a
     scroll container and sticky stops working inside it. */
  function freeSticky(root) {
    var el = root.parentElement;
    while (el && el !== document.body) {
      var cs = getComputedStyle(el);
      if (cs.overflowX !== 'visible' && cs.overflowX !== 'clip') el.style.overflowX = 'clip';
      if (cs.overflowY !== 'visible' && cs.overflowY !== 'clip') el.style.overflowY = 'visible';
      el = el.parentElement;
    }
  }

  function boot() {
    document.querySelectorAll('.dc-g').forEach(function (root) {
      freeSticky(root);
      initLoops(root);
      initFacade(root);
    });
    var nav = document.querySelector('.dc-g-nav');
    if (nav) initSpy(nav);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
